export default {
    deep: true,
    bind(el) {
        // Verifica se o target é um input se não for busca por um input
        el = el instanceof HTMLInputElement ? el : el.querySelector("input")

        el.onkeydown = (event) => {
            const { key, keyCode, ctrlKey } = event
            const keys = [ '.', ',', 'Delete', 'Backspace', 'Tab', 'Esc', 'Escape', 'Enter', 'Home', 'End', 'PageUp', 'PageDown', 'Del', 'Delete', 'Left', 'ArrowLeft', 'Right', 'ArrowRight', 'Insert', 'Up', 'ArrowUp', 'Down', 'ArrowDown' ]

            // Permite as teclas dos números
            // Permite as teclas $keys
            // Permite copiar e colar com ctrl/cmd
            if (!((key >= '0' && key <= '9') || keys.includes(key) || (ctrlKey && [65, 67, 86, 88].includes(keyCode))))
                event.preventDefault()
        }
    }
}